import React from 'react';
import { Link } from 'react-router-dom';

export const articles = [
  {
    slug: 'create-openai-api-key',
    category: 'Guide',
    href: '/blog/guides/create-openai-api-key',
    date: 'August 2, 2026',
    title: 'How to Create an OpenAI API Key for Promptera',
    excerpt: 'Create a private OpenAI project key, configure API billing safely, and connect it through Promptera’s Key Vault.',
    readTime: '4 min read',
  },
  {
    slug: 'prompting-with-purpose',
    category: 'Guide',
    href: '/blog/guides/prompting-with-purpose',
    date: 'July 31, 2026',
    title: 'Prompting with purpose: a practical guide to better AI results',
    excerpt: 'Clear tasks, useful context, and a thoughtful iteration loop turn AI from a chat window into dependable work.',
    readTime: '8 min read',
  },
  {
    slug: 'prompt-engineering-basics',
    category: 'Guide',
    href: '/blog/guides/prompt-engineering-basics',
    date: 'July 31, 2026',
    title: 'Prompt Engineering Basics: A Practical Framework for Better AI Results',
    excerpt: 'A practical framework for giving AI clear instructions, useful context, and a defined output shape.',
    readTime: '1 min read',
  },
  {
    slug: 'prompt-management',
    category: 'Solution',
    href: '/blog/solutions/prompt-management',
    date: 'July 31, 2026',
    title: 'Prompt Management for Teams Building Reliable AI Workflows',
    excerpt: 'See how a shared workspace helps teams create, test, improve, and version the prompts behind everyday AI work.',
    readTime: '1 min read',
  },
  {
    slug: 'how-to-write-better-prompts',
    category: 'Guide',
    href: '/blog/guides/how-to-write-better-prompts',
    date: 'July 31, 2026',
    title: 'How to Write Better Prompts for Consistent AI Workflows',
    excerpt: 'Learn how clearer prompt structure, useful limits, and deliberate iteration lead to more dependable AI results.',
    readTime: '2 min read',
  },
];

const categoryDetails = {
  Guide: {
    title: 'Practical guides for better AI work.',
    description: 'Step-by-step guidance for writing clearer prompts and building more dependable AI workflows.',
  },
  Solution: {
    title: 'Solutions for reliable AI workflows.',
    description: 'Explore practical ways to organize, improve, and scale prompt work with your team.',
  },
};

export default function BlogPage({ category }){
  const details = category ? categoryDetails[category] : {
    title: 'Ideas, guides, and practical ways to work with AI.',
    description: 'Practical articles to help you create clearer prompts and build more dependable AI workflows.',
  };
  const visibleArticles = category ? articles.filter((article) => article.category === category) : articles;

  return (
    <main className="updates-page">
      <section className="updates-hero" aria-labelledby="updates-title">
        <div className="container">
          <p className="updates-kicker">Promptera blog</p>
          <h1 id="updates-title">{details.title}</h1>
          <p>{details.description}</p>
          <nav className="blog-taxonomy" aria-label="Browse blog topics">
            <Link className={!category ? 'is-active' : ''} to="/blog">All articles</Link>
            <Link className={category === 'Guide' ? 'is-active' : ''} to="/blog/guides">Guides</Link>
            <Link className={category === 'Solution' ? 'is-active' : ''} to="/blog/solutions">Solutions</Link>
          </nav>
        </div>
      </section>

      <section className="updates-list-section" aria-label="Promptera blog articles">
        <div className="container updates-list">
          {visibleArticles.map((article) => (
            <article className="updates-card glass" key={article.slug}>
              <div className="updates-card-meta">
                <span>{article.category}</span>
                {article.date && <time>{article.date}</time>}
              </div>
              <h2><Link to={article.href}>{article.title}</Link></h2>
              <p>{article.excerpt}</p>
              <div className="updates-card-footer">
                {article.readTime && <span>{article.readTime}</span>}
                <Link className="updates-read-link" to={article.href}>Read article <span aria-hidden="true">→</span></Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
